import { useState, useEffect } from "react";
import React from "react";
import { machineProfile, customer, customerType } from "../../api";
import { toast } from "react-toastify";
import { dateFormat, getEmptyField, printLocation, renderImage } from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import { DatepickerOpt } from "../../components/form/DatepickerOpt";
import DateTime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}
function AddCustomer() {
  const { id } = useParams();
  const editMode = !!id;
  const { locations } = useDashboardContext();
  const [sublocations, setSublocations] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [deletedDocument, setDeletedDocument] = useState([]);
  const [profilePicture, setProfilePicture] = useState(null);
  const [selectedFile, setSelectedFile] = useState("");
  const [docName, setDocName] = useState(null);
  const [machineClasses, setCustomerClasses] = useState([]);
  const [areas, setAreas] = useState([]);
  const [schedules, setSchedules] = useState([]);
  const [sensors, setSensors] = useState([""]);
  const [filesToUpload, setFilesToUpload] = useState([]);
  const [preview, setPreview] = useState();
  const [machineSpec, setCustomerSpec] = useState("");
  const [productManual, setProductManual] = useState("");
  const [otherDoc, setOtherDoc] = useState("");
  const [machineElements, setCustomerElements] = useState([]);
  const [deletedElements, setDeletedElements] = useState([]);
  const [deletedDeployments, setDeletedDeployments] = useState([]);
  const [deletedSchedules, setDeletedSchedules] = useState([]);
  const [deletedAttachments, setDeletedAttachments] = useState([]);
  const [locationValue, setLocationValue] = useState([]);
  const { getLocationName } = useAuth();
  const [isLoading, setIsLoading] = useState(true);

  const [dataToSend, setDataToSend] = useState({
    customer_name: "",
    type_id: "",
    contact_name: "",
    contact_email: "",
    contact_phone: "",
    address: "",
    website: "",
    description: "",
  });
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  const [types, setTypes] = useState([])
  const [newType, setNewType] = useState("")
  const [emptyField,setEmptyField] = useState([])

  const handleAddNewType = async() => {
    
    if (!newType) return;
    const result = await  customerType.create({
      name:newType
    });

    if (result.ok) {
      const body = await result.json()
      const data = body.data
      setTypes((prev)=>[{...data},...prev])
      setNewType("")
    }


  }
  
  async function getMasterData() {
    try {
      setIsLoading(true);

      const resType = await customerType.list({})
      if (resType.ok) {
        const body = await resType.json();
        let data = body.data;
        if (data) {
          setTypes(data);
        }
      }



      if (editMode) {
        await getRecord();
      } else {
        setIsLoading(false);
      }
    } catch (err) {}
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  async function getRecord() {
    const machine = await customer.getOne({ id });
    let activeCustomer;
    if (machine.ok) {
      const body = await machine.json();
      let data = body.data;
      activeCustomer = data;
    }

    if (activeCustomer) {
      const defaultValue = {
        customer_name: activeCustomer.customer_name,
        type_id: activeCustomer.type_id,
        contact_name: activeCustomer.contact_name,
        contact_email: activeCustomer.contact_email,
        contact_phone: activeCustomer.contact_phone,
        address: activeCustomer.address,
        website: activeCustomer.website,
        description: activeCustomer.description,
      };

      setDataToSend((prevData) => ({
        ...prevData,
        ...defaultValue,
      }));
      setIsLoading(false);
    }
  }

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };

  const handleCustomerElementChange = (elements) => {
    setDataToSend((prevData) => ({
      ...prevData,
      deployments: JSON.stringify(elements),
    }));
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  const handleLocationChange = (e, index) => {
    const location_values = [...locationValue];
    location_values.splice(index);
    location_values.push(e.target.value);
    setLocationValue(location_values);
  };
  const onAddChedule = (e) => {
    let copy = [...schedules];
    copy = [...copy, e];
    setSchedules(copy);
    //console.log({ schedules });
    setOpen(false);
  };

  const handleSubmit = async () => {
    try {
      let hasil = { ...dataToSend };

      const mandatory = ['customer_name', 'type_id']
      const ef = getEmptyField(hasil, mandatory)
      setEmptyField(ef)
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }


      //console.log({ hasil });
      setIsLoading(true);
      const res = await customer.create2(hasil, selectedFile);
      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
        backToList();
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  const handleEdit = async () => {
    try {
      let hasil = { ...dataToSend };

      const mandatory = ['customer_name', 'type_id']
      const ef = getEmptyField(hasil, mandatory)
      setEmptyField(ef)
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      setIsLoading(true);
      const res = await customer.update(id, hasil);
      setIsLoading(false);
      if (res.ok) {
        toast.success("Successfully Saved");
      } else {
        toast.error("Something went wrong, please try again");
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  };

  const handleDateChange = (newValue) => {
    setDataToSend((prevData) => ({
      ...prevData,
      ["purchase_date"]: newValue,
    }));
  };
  const handleWarrantyDateChange = (newValue) => {
    setDataToSend((prevData) => ({
      ...prevData,
      ["warranty_date"]: newValue,
    }));
  };

  const onSelectTime = (key, moment) => {
    const time = moment.format("H:mm");

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: time,
    }));
  };
  const suspect_reason = [
    {
      uid: "Low Lubrican Oil",
      name: "Low Lubrican Oil",
    },
    {
      uid: "Engine Failure",
      name: "Engine Failure",
    },
  ];
  const generateRandomQR = () => {
    //random number 16 character with prefix GR-
    //example GR-123456919191929
    // random number only wihtout string
    // example 123456919191929
    const random = Math.floor(Math.random() * 10000000000000000);
    setDataToSend((prevData) => ({
      ...prevData,
      ["barcode"]: `GR-${random}`,
    }));
  };
  const onCustomerSpecFileClick = (e) => {
    document.getElementById("machinespecfile").click();
  };
  const handleCustomerSpecChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setCustomerSpec(undefined);
      return;
    }
    setCustomerSpec(e.target.files[0]);
  };

  function onUpdateELement() {
    getRecord();
  }

  const onProductManualFileClick = (e) => {
    document.getElementById("productmanualfile").click();
  };
  const handleProductManualChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setProductManual(undefined);
      return;
    }
    //console.log("e.target.files[0]", e.target.files[0]);
    setProductManual(e.target.files[0]);
  };
  const onOtherDocFileClick = (e) => {
    document.getElementById("otherdocfile").click();
  };
  const handleOtherDocChange = async (e) => {
    //console.log("on select file");
    if (!e.target.files || e.target.files.length === 0) {
      setOtherDoc(undefined);
      return;
    }
    setOtherDoc(e.target.files[0]);
  };
  const onSelectFile = async (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setSelectedFile(undefined);
      return;
    }

    // I've kept this example simple by using the first image instead of multiple
    setSelectedFile(e.target.files[0]);
  };

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);
  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>{editMode && "Edit "}Customer Information</CardHeader>

      <CardBody>
        <div className="row">
          <div className="col-9">
            <div>
              <NormalInput
                required={true}
                value={dataToSend["customer_name"]}
                label="Customer Name"
                onchange={handleOnchange}
                name="customer_name"
                emptyField={emptyField}
              />

<NormalSelect
                required={true}
                value={dataToSend["type_id"]}
                label="Customer Type"
                onchange={handleOnchange}
                list={types}
                name="type_id"
              valueKey={"id"}
                onSubmit={handleAddNewType}
                emptyField={emptyField}
              addMoreComponent={
                <NormalInput
                required={true}
                value={newType}
                label="Customer Type"
                onchange={(e)=>{setNewType(e.target.value)}}
              />
              }
              />
              
              <NormalInput
                value={dataToSend["address"]}
                label="Address"
                onchange={handleOnchange}
                name="address"
              />
              <NormalInput
                value={dataToSend["website"]}
                label="Website"
                onchange={handleOnchange}
                name="website"
              />
              <NormalInput
                value={dataToSend["contact_name"]}
                label="Contact Name"
                onchange={handleOnchange}
                name="contact_name"
              />
              <NormalInput
                value={dataToSend["contact_phone"]}
                label="Contact Phone"
                onchange={handleOnchange}
                name="contact_phone"
              />
              <NormalInput
                value={dataToSend["contact_email"]}
                label="Contact Email"
                onchange={handleOnchange}
                name="contact_email"
              />
              <NormalTextArea
                value={dataToSend["description"]}
                label="Description"
                onchange={handleOnchange}
                name="description"
              />
            </div>
          </div>
        </div>

        <div className="mt-4 flex ">
          <button
            className="btn btn-outline-theme btn-lg me-2"
            onClick={editMode ? handleEdit : handleSubmit}
          >
            {editMode ? "SAVE" : "ADD"}
          </button>
          <button
            className="btn btn-outline-danger btn-lg"
            onClick={backToList}
          >
            CANCEL
          </button>
        </div>
      </CardBody>
    </Card>
  );
}

export default AddCustomer;
